import React from 'react';
import { SimpleTextLayoutProps } from 'ui-builder';

export default function TextLayout(
  props: SimpleTextLayoutProps,
) {
  return (
    <span className={props.className}>{props.children}</span>
  );
}
